import { createContext, useState, useEffect } from 'react';
import { isActiveUserSubscription } from '../api/service';

const SubscriptionContext = createContext();

const SubscriptionProvider = ({ children }) => {
	const [subscription, setSubscription] = useState(null);
	const [user, setUser] = useState(null);

	useEffect(() => {
		const storedUser = localStorage.getItem('user');
		if (storedUser && storedUser !== 'null') {
			setUser(JSON.parse(storedUser));
		} else {
		}
	}, [setUser]);

	useEffect(() => {
		const storedSubscription = localStorage.getItem('subscription');
		if (storedSubscription && storedSubscription !== 'null' && storedSubscription !== 'undefined') {
			setSubscription(JSON.parse(storedSubscription));
		} else {
			let userId;
			const localStorageUser = localStorage.getItem('userData');

			if (user) {
				userId = user.userId;
			} else if (localStorageUser) {
				userId = JSON.parse(localStorageUser).userId;
			} else {
				return;
			}

			// Fetch membership data from API or initialize as null
			isActiveUserSubscription(userId, null).then((data) => updateSubscription(data));
		}
	}, [user]);

	const updateSubscription = (newSubscription) => {
		console.log('updateSubscription', newSubscription);
		setSubscription(newSubscription);
		localStorage.setItem('subscription', JSON.stringify(newSubscription));
	};

	const updateUser = (user) => {
		setUser(user);
	};

	return (
		<SubscriptionContext.Provider value={{ subscription, updateSubscription, user, updateUser }}>
			{children}
		</SubscriptionContext.Provider>
	);
};

export { SubscriptionProvider, SubscriptionContext };
